"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.distanceHorizontale = distanceHorizontale;
exports.distanceVerticale = distanceVerticale;
exports.gaucheRelative = gaucheRelative;
exports.topRelatif = topRelatif;
exports.gauche = gauche;
exports.top = top;
exports.largeur = largeur;
exports.hauteur = hauteur;
exports.premierParentRelatif = premierParentRelatif;
exports.obtenirElementDeroulant = obtenirElementDeroulant;
exports.deroulerVersTopElement = deroulerVersTopElement;
exports.remplacerComposante = remplacerComposante;
exports.declencherEvennement = declencherEvennement;

var _utilitaires = require("./utilitaires");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function distanceHorizontale(elementCible, elementParent, relatif) {
  if (!(0, _utilitaires.estDefini)(elementParent)) {
    elementParent = elementCible.parentElement;
  }

  return operationGauche(elementCible, elementParent, function (a, b) {
    return a - b;
  }, relatif);
}

function distanceVerticale(elementCible, elementParent, relatif) {
  if (!(0, _utilitaires.estDefini)(elementParent)) {
    elementParent = elementCible.parentElement;
  }

  return operationTop(elementCible, elementParent, function (a, b) {
    return a - b;
  }, relatif);
}

function gaucheRelative(element) {
  return valeurRectangleRelative(element, 'left');
}

function topRelatif(element) {
  return valeurRectangleRelative(element, 'top');
}

function valeurRectangleRelative(element, nomPropriete) {
  var parent = premierParentRelatif(element);

  if (!(0, _utilitaires.estDefini)(parent)) {
    parent = element;
  } else {
    var _getComputedStyle = getComputedStyle(parent),
        position = _getComputedStyle.position;

    if (!(0, _utilitaires.estDefini)(position) || position !== 'relative') {
      parent = element;
    }
  }

  return valeurRectangleDifference(element, parent, nomPropriete);
}

function valeurRectangleDifference(elementA, elementB, nomPropriete) {
  var valeurElement = valeurRectangle(elementA, nomPropriete);
  var valeurParent = valeurRectangle(elementB, nomPropriete);
  return valeurElement - valeurParent;
}

function valeurRectangle(element, nomPropriete) {
  var rectangle = element.getBoundingClientRect();
  return rectangle[nomPropriete];
}

function operationRectangle(elementA, elementB, callback, nomPropriete, relatif) {
  var fonction = relatif ? valeurRectangleRelative : valeurRectangle;
  return callback(fonction(elementA, nomPropriete), fonction(elementB, nomPropriete));
}

function operationGauche(elementA, elementB, callback) {
  return operationRectangle(elementA, elementB, callback, 'left');
}

function operationTop(elementA, elementB, callback) {
  return operationRectangle(elementA, elementB, callback, 'top');
}

function gauche(element) {
  return valeurRectangle(element, 'left');
}

function top(element) {
  return valeurRectangle(element, 'top');
}

function largeur(element) {
  return valeurRectangle(element, 'width');
}

function hauteur(element) {
  return valeurRectangle(element, 'height');
}

function premierParentRelatif(element) {
  var parent = element.parentElement;

  while ((0, _utilitaires.estDefini)(parent) && parent.tagName !== 'BODY') {
    var _getComputedStyle2 = getComputedStyle(parent),
        position = _getComputedStyle2.position;

    if ((0, _utilitaires.estDefini)(position) && position === 'relative') {
      return parent;
    }

    parent = parent.parentElement;
  }

  return null;
}

function obtenirElementDeroulant(element) {
  var position = element.scrollTop;

  if ((0, _utilitaires.estDefini)(position) && position > 0) {
    return element;
  }

  var parent = element.parentElement;

  while ((0, _utilitaires.estDefini)(parent)) {
    var _parent = parent,
        scrollTop = _parent.scrollTop;

    if ((0, _utilitaires.estDefini)(scrollTop) && scrollTop > 0) {
      return parent;
    }

    parent = parent.tagName === 'BODY' ? document.documentElement : parent.parentElement;
  }

  return null;
}

function deroulerVersTopElement(element) {
  var velocite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var acceleration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.05;
  var callbackApres = arguments.length > 3 ? arguments[3] : undefined;

  var callbackApresEffectif = function callbackApresEffectif() {
    return (0, _utilitaires.estDefini)(callbackApres) ? callbackApres() : null;
  };

  if (!(0, _utilitaires.estDefini)(element)) {
    callbackApresEffectif();
    return;
  }

  var elementDeroulant = obtenirElementDeroulant(element);

  if (!(0, _utilitaires.estDefini)(elementDeroulant)) {
    callbackApresEffectif();
    return;
  }

  var fonctionPositionZero = function fonctionPositionZero() {
    return elementDeroulant.scrollTop <= 0;
  };

  var fonctionFin = fonctionPositionZero;

  var fonctionIteration = function fonctionIteration() {
    var scrollTop = elementDeroulant.scrollTop;
    elementDeroulant.scrollTop = Math.max(0, scrollTop - (velocite *= acceleration));
  };

  if (elementDeroulant !== element) {
    var difference = valeurRectangleDifference(element, elementDeroulant, 'top');
    var scrollTop = elementDeroulant.scrollTop;

    if (scrollTop === 0 || difference - scrollTop > 0) {
      callbackApresEffectif();
      return;
    }

    fonctionFin = function fonctionFin() {
      var zero = fonctionPositionZero();
      var differenceTop = valeurRectangleDifference(element, elementDeroulant, 'top');
      var difference = differenceTop - elementDeroulant.scrollTop;
      return zero || difference >= 0;
    };
  }

  (0, _utilitaires.boucleAsyncrone)(fonctionIteration, fonctionFin, 5, callbackApres);
}

function remplacerComposante(parent, enfantARemplace, remplacement) {
  return /*#__PURE__*/(0, _react.cloneElement)(parent, null, _react.default.Children.map(parent.props.children, function (enfant) {
    if (enfant === enfantARemplace) {
      return remplacement;
    }

    return remplacerComposante(enfant, enfantARemplace, remplacement);
  }));
}

function declencherEvennement(element, type) {
  var bubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var cancellable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!(0, _utilitaires.estDefini)(element, 'dispatchEvent')) {
    return;
  }

  var evennement = document.createEvent('Event');
  evennement.initEvent(type, bubble, cancellable);
  element.dispatchEvent(evennement);
}